import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

const TermsAndConditions = () => {
  const [activeTab, setActiveTab] = useState("terms");

  const primary = "#ff4d4f";

  const styles = {
    page: {
      background: "linear-gradient(135deg, #fff5f5, #ffecec)",
      minHeight: "100vh",
    },
    container: {
      maxWidth: "1000px",
      margin: "0 auto",
      padding: "30px 20px",
      fontFamily: "Poppins, sans-serif",
    },
    headerBox: {
      textAlign: "center",
      marginBottom: "30px",
    },
    title: {
      fontSize: "36px",
      fontWeight: "700",
      color: primary,
      marginBottom: "10px",
    },
    subtitle: {
      color: "#666",
      fontSize: "15px",
    },
    tabs: {
      display: "flex",
      justifyContent: "center",
      gap: "12px",
      marginBottom: "25px",
      flexWrap: "wrap",
    },
    tabBtn: (active) => ({
      padding: "10px 22px",
      borderRadius: "30px",
      border: `1px solid ${primary}`,
      background: active ? primary : "#fff",
      color: active ? "#fff" : primary,
      cursor: "pointer",
      fontWeight: "600",
      boxShadow: active
        ? "0 4px 12px rgba(255,77,79,0.4)"
        : "0 2px 6px rgba(0,0,0,0.1)",
      transition: "0.3s",
    }),
    grid: {
      display: "grid",
      gap: "20px",
    },
    card: {
      background: "#fff",
      padding: "20px",
      borderRadius: "14px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      borderLeft: `5px solid ${primary}`,
    },
    heading: {
      color: primary,
      fontSize: "18px",
      marginBottom: "10px",
      fontWeight: "600",
    },
    text: {
      color: "#555",
      fontSize: "14px",
      lineHeight: "1.6",
    },
    list: {
      paddingLeft: "18px",
      color: "#555",
      fontSize: "14px",
      lineHeight: "1.6",
    },
  };

  return (
    <div style={styles.page}>
      <Header />

      <div style={styles.container}>
        {/* Header */}
        <div style={styles.headerBox}>
          <h1 style={styles.title}>Terms & Conditions</h1>
          <p style={styles.subtitle}>
            Please read our terms and refund policy carefully before making any
            transactions.
          </p>
        </div>

        {/* Tabs */}
        <div style={styles.tabs}>
          <button
            style={styles.tabBtn(activeTab === "terms")}
            onClick={() => setActiveTab("terms")}
          >
            Terms
          </button>

          <button
            style={styles.tabBtn(activeTab === "refund")}
            onClick={() => setActiveTab("refund")}
          >
            Refund Policy
          </button>
        </div>

        {/* CONTENT */}
        <div style={styles.grid}>
          {activeTab === "terms" && (
            <>
              <div style={styles.card}>
                <h2 style={styles.heading}>💳 Payment Methods</h2>
                <ul style={styles.list}>
                  <li>Credit / Debit Cards</li>
                  <li>UPI & Net Banking</li>
                  <li>Wallets & digital payments</li>
                </ul>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>💰 Currency</h2>
                <p style={styles.text}>All payments are processed in INR.</p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>⚡ Processing</h2>
                <p style={styles.text}>
                  Payments are processed instantly or within 24 hours.
                </p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>⚠️ Failed Transactions</h2>
                <ul style={styles.list}>
                  <li>No deduction OR</li>
                  <li>Refund within 5–7 working days</li>
                </ul>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>🔒 Security</h2>
                <p style={styles.text}>
                  SSL secured payments. No card data stored.
                </p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>📞 Contact</h2>
                <p style={styles.text}>
                  Email: dzyrisfrozenfoods@gmail.com <br />
                  Phone: +91 9022707285
                </p>
              </div>
            </>
          )}

          {activeTab === "refund" && (
            <>
              <div style={styles.card}>
                <h2 style={styles.heading}>✅ Eligibility</h2>
                <ul style={styles.list}>
                  <li>Duplicate payment</li>
                  <li>Service not delivered</li>
                  <li>Technical error</li>
                </ul>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>📄 Process</h2>
                <ul style={styles.list}>
                  <li>Send email request</li>
                  <li>Provide transaction details</li>
                  <li>Apply within 7 days</li>
                </ul>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>💸 Refund Mode</h2>
                <p style={styles.text}>
                  Refunds via original payment method only.
                </p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>⏳ Timeline</h2>
                <p style={styles.text}>7–10 business days.</p>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>❌ Non-Refundable</h2>
                <ul style={styles.list}>
                  <li>Delivered services</li>
                  <li>Late requests</li>
                </ul>
              </div>

              <div style={styles.card}>
                <h2 style={styles.heading}>👤 Contact</h2>
                <p style={styles.text}>
                  Email: dzyrisfrozenfoods@gmail.com <br />
                  Phone: +91 9022707285 <br />
                  Officer: Soyab Sheikh
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;